import { Injectable } from '@angular/core';
import * as faIconsSolid from "@fortawesome/free-solid-svg-icons";
import * as faIconsRegular from "@fortawesome/free-regular-svg-icons";

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  public faIconsSolid = faIconsSolid;
  public faIconsRegular = faIconsRegular;
  constructor() { }
}
